/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../../config';
import OperationSettings from './OperationSettings';
import SalesSettings from './SalesSettings';
import SupplySettings from './SupplySettings';
import PricingSettings from './PricingSettings';

import './styles/index.scss';
import { NotificationsManagement } from "./NotificationsManagment";
import { SmsManagement } from "./SMSManagement";
import AppVersion from "./AppVersion";
import { fetchLoggedInAsync } from "../../actions/ClientData";
import { getErrorMessages } from "../../utils";

class SystemSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: null,
            settingsContainerKey: Date.now(),
        };

        this.updateSettingsData = this.updateSettingsData.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.clientData.userData.content.agency_detail;
        this.fetchSettingsDataAsync(id);
    }

    fetchSettingsDataAsync(id) {
        axios({
            method: 'GET',
            url: `${ROOT_URL_V2}agencies/${id}/settings/`,
        })
            .then(response => {
                this.setState({
                    settingsData: response.data.content,
                });
            })
            .catch(error => {
                const status = error.response.status.toString();
                if (status.substring(0, 2) === '40') {
                    this.props.history.push('/');
                }
            });
    }

    updateSettingsData(fields) {
        const { id } = this.props.clientData.userData.content.agency_detail;
        return axios({
            method: 'PATCH',
            url: `${ROOT_URL_V2}agencies/${id}/settings/`,
            data: fields,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                this.props.notification.success('Success', 'Settings updated successfully');
                this.setState({
                    settingsData: response.data.content,
                });
                this.resetFields();
                this.props.fetchLoggedInAsync();
                return response;
            })
            .catch(error => {
                this.props.notification.error('Error', getErrorMessages(error));
                this.resetFields();
            });
    }

    resetFields = () => {
        this.setState({ settingsContainerKey: Date.now() });
    };

    render() {
        const { settingsData, settingsContainerKey } = this.state;
        if (settingsData) {
            return (
                <div className="settings-container" key={settingsContainerKey}>
                    <OperationSettings
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                    />
                    <SalesSettings
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                        resetFields={this.resetFields}
                        servicesStructure={this.props.servicesStructure}
                    />
                    <SupplySettings
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                        resetFields={this.resetFields}
                        servicesStructure={this.props.servicesStructure}
                        notification={this.props.notification}
                    />
                    <PricingSettings
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                        notification={this.props.notification}
                    />
                    <NotificationsManagement
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                    />
                    <SmsManagement
                        settingsData={settingsData}
                        onSettingChange={this.updateSettingsData}
                    />
                    {this.props.user && this.props.user.isSuperUser && <AppVersion />}
                </div>
            );
        }

        return (
            <div className="fetching-freelancer-info">
                <i className="icon icon-loading-1" />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        clientData: state.clientData,
        servicesStructure: state.servicesStructure,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchLoggedInAsync: () => dispatch(fetchLoggedInAsync()),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SystemSettings));
